module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '373j3m6u',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
